import React from "react";
import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Form,
    FormGroup,
    Input,
    Row,
    Col,
    Button,
  } from "reactstrap";
import isAuthenticated from "../scripts/Tokens";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import NotificationAlert from "react-notification-alert";


var ps;

function Welcome(props) {
    const navigate = useNavigate();
    const mainPanel = React.useRef();
    const location = useLocation();
    
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");

    const notificationAlert = React.useRef();
    const notify = (message) => {
        var options = {
        place: "tr",
        message: (
            <div>
            <div>
                {message}
            </div>
            </div>
        ),
        type: "danger",
        icon: "nc-icon nc-bell-55",
        autoDismiss: 7,
        };
        notificationAlert.current.notificationAlert(options);
    }

    React.useEffect(() => {
        if (navigator.platform.indexOf("Win") > -1) {
          ps = new PerfectScrollbar(mainPanel.current);
          document.body.classList.toggle("perfect-scrollbar-on");
        }
        return function cleanup() {
          if (navigator.platform.indexOf("Win") > -1) {
            ps.destroy();
            document.body.classList.toggle("perfect-scrollbar-on");
          }
        };
      });
      React.useEffect(() => {
        mainPanel.current.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
      }, [location]);


    React.useEffect(() => {
        if(isAuthenticated()){
            navigate('/admin/dashboard', { replace: true });
        }
      }, []);

    async function onClickSkip(event) {
        console.log("Continue without login...")
        navigate('/admin/dashboard', { replace: true });
    }


    async function onClickLogin(event) {
        event.preventDefault();
        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);
        urlencoded.append("password", password);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + "/login", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: urlencoded,
            });
            if(response.status === 200) {
                var body = await response.json();
                localStorage.setItem("accessToken", body.accessToken);
                localStorage.setItem("refreshToken", body.refreshToken);
                if(isAuthenticated()){
                    navigate('/admin/dashboard', { replace: true });
                }
            }
            else if(response.status === 401 || response.status === 403) {
                notify("Invalid email or password");
            }
            else {
                console.log("API error");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }


    return (
    <>
        <NotificationAlert ref={notificationAlert} />
        <div className="wrapper">
        <div className="main-panel" ref={mainPanel} style={{width:"100%"}}>
            <DemoNavbar {...props} />

            <div className="content">
                <Row style={{justifyContent:"center", alignContent:"center" , height:"500px"}}>
                    <Col lg="6" md="8" sm="12">
                        <Card className="card-stats">
                            <CardBody style={{paddingBottom:"15px"}}>
                                <Form >
                                    <Row style={{justifyContent:"center"}}>
                                        <Col lg="6" md="8" xs="12">
                                            <FormGroup>
                                                <label>Email address</label>
                                                <Input placeholder="Email" type="email" 
                                                    value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row style={{justifyContent:"center"}}>
                                        <Col lg="6" md="8" xs="12">
                                            <FormGroup>
                                                <label>Password</label>
                                                <Input placeholder="***" type="password" 
                                                    value={password} onChange={(e) => setPassword(e.target.value)} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="update ml-auto mr-auto">
                                            <Button
                                                className="btn-round"
                                                color="primary"
                                                type="submit"
                                                onClick={onClickLogin}
                                            >
                                                Log In
                                            </Button>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="update ml-auto mr-auto">
                                            <Button
                                                className="btn-round"
                                                color="secondary"
                                                type="submit"
                                                onClick={onClickSkip}
                                            >
                                                Skip
                                            </Button>
                                        </div>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
        </div>
    </>
    );

}

export default Welcome;